import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col py-10 px-4 justify-center space-y-10" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col space-y-2"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col space-y-2"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex space-x-4" }
const _hoisted_6 = { class: "flex w-10 h-10 relative" }
const _hoisted_7 = {
  key: 0,
  class: "flex w-5 h-5 rounded-full bg-brand-blue absolute -bottom-0.5 -right-0.5 border-brand-black border-2"
}
const _hoisted_8 = { class: "flex space-x-2" }
const _hoisted_9 = { class: "flex text-white text-lg font-medium my-auto" }
const _hoisted_10 = {
  key: 2,
  class: "flex flex-col space-y-2"
}
const _hoisted_11 = { class: "font-medium text-white" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex space-x-2" }
const _hoisted_14 = { class: "flex text-white text-lg font-medium my-auto" }
const _hoisted_15 = { class: "flex m-auto space-x-2.5" }
const _hoisted_16 = { class: "my-auto pt-0.5" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "my-auto"
}

import {
  actionSheetController, alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  onIonViewWillEnter,
  useIonRouter,
} from '@ionic/vue';
import {inject, Ref, ref, watch} from 'vue';
import ApiService from "@/services/api/apiService";
import {DateTime} from "luxon";
import MenuButton from "@/components/MenuButton.vue";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {UserInterface} from "@/interfaces/UserInterface";
import InputField from "@/components/InputField.vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import _ from "lodash";
import UserVerificationCheck from "@/components/UserBadges.vue";
import pluralize from "pluralize";
import {useUser} from "@/composables/useUser";
import UserAvatar from "@/components/UserAvatar.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSettingsPartnerSearch',
  setup(__props) {

const user: Ref<UserInterface | undefined> = inject('user') as Ref<UserInterface | undefined>

const loading = ref(true)
const ionRouter = useIonRouter()
const busy = ref(false)

const partnerSearch = ref('')
const partnerSearchResults: Ref<UserBasicInformationInterface[]> = ref([])
const partnerSearchResultsCopy: Ref<UserBasicInformationInterface[]> = ref([])

const partnerInvites: Ref<UserBasicInformationInterface[]> = ref([])


watch(() => partnerSearch.value, async query => {
  partnerSearchResults.value = await ApiService.Search().users(query)
  partnerSearchResultsCopy.value = _.cloneDeep(partnerSearchResults.value)
})

onIonViewWillEnter(async () => {
  loading.value = false
})

const goBack = async () => {
  await ionRouter.back()
}

const sendRequest = async () => {
  if (!partnerInvites.value.length) return
  busy.value = true
  try {
    await useUser().makePartnerRequest(partnerInvites.value[0].id)
    await ionRouter.back()
  } catch (e) {
    //
  } finally {
      busy.value = false
  }
}

watch(() => partnerInvites.value, async partners => {
  const partnerIds = partners.map((p) => p.id)
  partnerSearchResults.value = partnerSearchResultsCopy.value.filter((partner) => {
    return !partnerIds.includes(partner.id)
  })
}, {deep: true})

const addToInvite = (partner: UserBasicInformationInterface) => {
  partnerInvites.value.push(partner)
  partnerSearch.value = ''
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { class: "text-white font-medium text-2xl" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Find your partner", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "h-full" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!partnerInvites.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(InputField, {
                    placeholder: "Search by username",
                    "clear-input": true,
                    debounce: 300,
                    modelValue: partnerSearch.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((partnerSearch).value = $event))
                  }, {
                    "icon-start": _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z",
                          stroke: "#FFFFFF",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (partnerInvites.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partnerInvites.value, (partner, participantIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      onClick: ($event: any) => (partnerInvites.value.splice(participantIndex,1)),
                      key: partner.id,
                      class: "rounded-2xl bg-brand-dark-gray text-white flex px-4 py-3 justify-between"
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", {
                            style: _normalizeStyle({
                                    'background-image' : `url('${partner.avatar_thumbnail ?? partner.avatar}')`
                                }),
                            class: "w-full rounded-full h-full absolute top-0 left-0 bg-brand-black bg-cover bg-center relative"
                          }, [
                            (partner.relationship_status === 'couple')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                                  _createElementVNode("div", { class: "flex m-auto text-brand-black text-opacity-80" }, [
                                    _createElementVNode("svg", {
                                      class: "h-2.5 w-2.5 fill-current",
                                      width: "24",
                                      height: "25",
                                      viewBox: "0 0 24 25",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                      _createElementVNode("path", { d: "M17.5291 19.2339L17.4684 19.0516C15.8278 15.9225 12.5468 13.7959 8.77975 13.7959C5.01266 13.7959 1.73165 15.9225 0.091139 19.0212L0.0303799 19.2035C1.15437e-07 19.2643 0 19.3554 0 19.4465V20.206C0 20.6617 0.394936 21.0567 0.850633 21.0567H8.77975H16.7392C17.1949 21.0567 17.5899 20.6617 17.5899 20.206V19.4465C17.5899 19.3858 17.5595 19.2946 17.5291 19.2339Z" }),
                                      _createElementVNode("path", { d: "M18.957 18.3531L18.9266 18.2923C17.9848 16.5303 16.6481 15.1024 15.0684 14.0695C15.919 13.6746 16.8911 13.4619 17.8937 13.4619C20.5063 13.4619 22.7544 14.9201 23.9089 17.0771L23.9696 17.1986C24 17.2594 24 17.3201 24 17.3505V17.867C24 18.2012 23.7266 18.4442 23.4228 18.4442H19.0177L18.957 18.3531Z" }),
                                      _createElementVNode("path", { d: "M17.8937 11.5784C19.4541 11.5784 20.719 10.3134 20.719 8.75305C20.719 7.19267 19.4541 5.92773 17.8937 5.92773C16.3333 5.92773 15.0684 7.19267 15.0684 8.75305C15.0684 10.3134 16.3333 11.5784 17.8937 11.5784Z" }),
                                      _createElementVNode("path", { d: "M8.74968 12.4896C11.1658 12.4896 13.1244 10.531 13.1244 8.11492C13.1244 5.69885 11.1658 3.74023 8.74968 3.74023C6.33361 3.74023 4.375 5.69885 4.375 8.11492C4.375 10.531 6.33361 12.4896 8.74968 12.4896Z" })
                                    ])
                                  ], -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ], 4)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(partner.name), 1),
                          _createVNode(UserVerificationCheck, {
                            class: "h-4",
                            user: partner
                          }, null, 8, ["user"])
                        ])
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex my-auto" }, [
                        _createElementVNode("svg", {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            d: "M12 22C10.6864 22.0013 9.38546 21.7436 8.17162 21.2415C6.95777 20.7394 5.85485 20.0029 4.926 19.074C3.99716 18.1452 3.26061 17.0423 2.75853 15.8284C2.25645 14.6146 1.99869 13.3136 2.00001 12V11.8C2.04001 9.83944 2.6553 7.93383 3.76939 6.32005C4.88348 4.70626 6.44726 3.45546 8.26636 2.72309C10.0855 1.99071 12.0797 1.80907 14.0012 2.20073C15.9227 2.59239 17.6867 3.54008 19.074 4.92603C20.4737 6.32457 21.4271 8.10693 21.8134 10.0475C22.1997 11.9881 22.0017 13.9997 21.2443 15.8277C20.487 17.6556 19.2043 19.2179 17.5588 20.3166C15.9132 21.4153 13.9787 22.0012 12 22ZM12 13.41L14.59 16L16 14.59L13.41 12L16 9.41003L14.59 8.00003L12 10.59L9.41001 8.00003L8.00001 9.41003L10.59 12L8.00001 14.59L9.41001 16L12 13.411V13.41Z",
                            fill: "#A5A7AF"
                          })
                        ])
                      ], -1))
                    ], 8, _hoisted_4))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (partnerSearch.value.length && partnerSearchResults.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, "Search results (" + _toDisplayString(partnerSearchResults.value.length) + ")", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partnerSearchResults.value, (partner) => {
                    return (_openBlock(), _createElementBlock("div", {
                      onClick: ($event: any) => (addToInvite(partner)),
                      key: partner.id,
                      class: "rounded-2xl bg-brand-dark-gray text-white flex px-4 py-3 space-x-4"
                    }, [
                      _createVNode(UserAvatar, { user: partner }, null, 8, ["user"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(partner.name), 1),
                        _createVNode(UserVerificationCheck, {
                          class: "h-4",
                          user: partner
                        }, null, 8, ["user"])
                      ])
                    ], 8, _hoisted_12))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: sendRequest,
              class: _normalizeClass([{
              'bg-opacity-40' : !partnerInvites.value.length
            }, "mx-auto w-full flex bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"])
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (!busy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Send request"))
                    : _createCommentVNode("", true),
                  (busy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("svg", {
                          class: "animate-spin h-5 w-5 text-brand-black",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})